module.exports = __webpack_public_path__ + "img/the-times.114ec479.svg";